import { render, staticRenderFns } from "./SetPickupRequest.vue?vue&type=template&id=6193eacd&"
import script from "./SetPickupRequest.vue?vue&type=script&lang=js&"
export * from "./SetPickupRequest.vue?vue&type=script&lang=js&"
import style0 from "./SetPickupRequest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports